import InterfaceUtility from "@/apiInterface/InterfaceUtility";
import InterfacePasien from "../apiInterface/InterfacePasien";
import ErrorAlert from "@/utility/ErrorAlert";

class DataUtility {
  async getListDokterByPoli(kdPoli) {
    let dt = [];
    await InterfaceUtility.getDokterByPoli(kdPoli)
      .then(response => {
        dt = response.data.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Dokter")
      });
    return dt;
  }
  async putDokterByPoli(register, unit_id, dokter_user_id, tgl) {
    let dt: any;
    await InterfaceUtility.changeDokterPoli(
      register,
      unit_id,
      dokter_user_id,
      tgl
    )
      .then(response => {
        dt = [response.data, response.status];
      })
      .catch(e => {
        // dt = e.response;
        // DataObject.showErrorAlert(e)
        // dt = dt = [{}, e.response.status];
        if (dt['status'] == 422) {
          dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        } else {
          dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        }
      });
    return dt;
  }
  async getListDokter() {
    let dt = {};
    await InterfaceUtility.getDokterAll()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Dokter")
      });
    return dt;
  }
  async getListDokterArray() {
    let dt: any = [];
    await InterfaceUtility.getDokterAll()
      .then(response => {
        dt = response;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Dokter")
      });
    return dt;
  }

  async getListPerawat() {
    let dt: any = [];
    await InterfaceUtility.getperawatAll()
      .then(response => {
        dt = response;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Perawat")
      });
    return dt;
  }

  async getListKaryawan() {
    let dt: any = [];
    await InterfaceUtility.getKaryawanAll()
      .then(response => {
        dt = response;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Karyawan")
      });
    return dt;
  }
  async getListPekerjaan() {
    let dt: any = [];
    await InterfaceUtility.getPekerjaan()
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = [];
        ErrorAlert.showSnackAlert(e, "List Pekerjaan");
      });
    return dt;
  }
  async getListFaskes() {
    let dt: any;
    await InterfaceUtility.getFaskes()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Faskes")
      });
    return dt;
  }
  async getListUnitRalanPagi() {
    let dt: any;
    await InterfaceUtility.getUnitRalanPagi()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Unit/Poli")
      });
    return dt;
  }
  async getListUnitRalanByIp(ip) {
    let dt: any;
    await InterfaceUtility.getUnitRalanByIp(ip)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Unit/Poli")
      });
    return dt;
  }
  async getListUnitRalan() {
    let dt: any;
    await InterfaceUtility.getUnitRalan()
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Unit")
      });
    return dt;
  }

  async getDataPerawatAutoComplete(term) {
    let dt = []
    await InterfaceUtility.getPerawatAutoComplete(term).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        // console.log(e);
      });
    return dt
  }

  async getDataDokterAutoComplete(term) {
    let dt = []
    await InterfaceUtility.getDokterAutoComplete(term).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        // console.log(e);
      });
    return dt
  }
}

export default new DataUtility();
